module.exports = __webpack_public_path__ + "static/media/uploadImage.21b163ef.svg";